const ITEMS = [
  "Austin",
  "Houston",
  "Dallas",
  "San Antonio",
  "Rio Grande Valley",
  "Fashion",
  "Food & Drink",
  "Real Estate",
  "Things to Do",
  "Be Seen",
];

const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee"
      className="bg-black text-white py-5 overflow-hidden border-y border-white/10"
    >
      <div className="marquee-track">
        {row.map((item, i) => (
          <span
            key={i}
            className="font-serif-display italic text-2xl md:text-3xl px-8 flex items-center gap-8"
          >
            {item}
            <span className="text-white/40 not-italic font-sans text-lg">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
